import React from "react";
import { useApp } from "@/contexts/AppContext";
import LoginForm from "@/components/LoginForm";
import Dashboard from "@/pages/Dashboard";
import { Loader2 } from "lucide-react";

const Index: React.FC = () => {
  const { currentUser, isInitializing } = useApp();

  if (isInitializing) {
    return (
      <div className="min-h-screen bg-restaurant-gray flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-restaurant-navy" />
          <p className="mt-2 text-restaurant-navy">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white p-0">
      {currentUser ? <Dashboard /> : <LoginForm />}
    </div>
  );
};

export default Index;
